import React, { Fragment } from "react"
import Feature from '../callouts/feature'
import TermHolder from '../callouts/termHolder'
import LatestBlogs from '../callouts/latestBlogs'

const pageBuilder = props => {
    let builds = '';

    if(props.data) {
      //console.log("Props data is: ", props.data)
      let slug = props.slug;

      builds = props.data.map((data, key) => {
        switch (data.__typename) {
          case 'ContentfulFeature':
            return (<Feature data={data} slug={slug} key={data.featureType + '_' + key} />);
          case 'ContentfulTermHolder':
            return (<TermHolder data={data} key={data.featureType + '_' + key} />);
          case 'ContentfulBlogList':
            return (<LatestBlogs data={data} key={data.featureType + '_' + key} />);
          default:
            return null;
        }
      });
    }

    return <Fragment>{ builds && builds }</Fragment>
}

export default pageBuilder
